import InfoIcon from '@ping/assets/Icon/info.svg';
import { calculate, t } from '@ping/helpers';
import { Tooltip } from '@ping/uikit/TooltipA11Y';

import style from './style.module.scss';

import type { GetQuoteResponse, MarketInfo } from '@ping/api';

interface IFormStructureFeeProps {
  pair: MarketInfo;
  feePercentage: number | string;
  quoteData?: GetQuoteResponse;
  orderSide?: 'buy' | 'sell';
}

export const FormStructureFeeRow = (props: IFormStructureFeeProps) => {
  // Use API fee when available, otherwise show percentage
  const feeDisplay =
    props.quoteData && props.orderSide
      ? calculate.order.feeValue(props.pair, props.quoteData, props.orderSide)
      : `${props.feePercentage}%`;

  return (
    <div className={style['form-structure-fee-row']}>
      <span className={style['form-structure-fee-row__text']}>
        <span>{t('Fee')}</span>
      </span>
      <Tooltip.Root className={style['form-structure-fee-row__tooltip']} openDelay={0}>
        <Tooltip.Trigger>
          <InfoIcon className={style['form-structure-fee-row__icon']} />
        </Tooltip.Trigger>
        <Tooltip.Content className={style['form-structure-tooltip-content']}>
          <span>{t('Maker: %s%', props.pair.makerFee * 100)}</span>
          <span className={style['form-structure-fee-row__divider']} />
          <span>{t('Taker: %s%', props.pair.takerFee * 100)}</span>
        </Tooltip.Content>
      </Tooltip.Root>
      <span className={style['form-structure-fee-row__text']}>{feeDisplay}</span>
    </div>
  );
};
